import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Edit from '../../../modal/Branch_Management/Manage_Delivery_Point/EditDeliveryPoint';
import AssignVehicle from '../../../modal/Branch_Management/Manage_Delivery_Point/AssignVehicle';

import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingComponent from '../../../layouts/nav/loading';

const Delivery_Point = () => {

    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ----------------------- branch --------------------
        man_branch: 0,
        branch_list: 0,
        branch_add: 0,
        branch_edit: 0,
        branch_view: 0,
        branch_delete: 0,
        branch_add_staff: 0,
        branch_add_area: 0,
        branch_add_dpoint: 0,
        branch_asign_manager: 0,
        branch_asign_cug: 0,

        man_dpoint: 0,
        dpoint_list: 0,
        dpoint_edit: 0,
        dpoint_delete: 0,
        dpoint_assign_vehicle: 0,

        // --------------------------- pack -------------------
        pack_man: 0,
        man_product: 0,
        prod_catego: 0,
        product_category_list: 0,
        product_category_add: 0,
        product_category_edit: 0,
        product_category_delete: 0,

        product: 0,
        products_list: 0,
        products_add: 0,
        products_edit: 0,
        products_view: 0,
        products_delete: 0,
        products_item_quantity: 0,

        item_quans: 0,
        item_quantity_list: 0,
        item_quantity_edit: 0,
        item_quantity_view: 0,

        man_pack: 0,
        package_list: 0,
        package_edit: 0,
        package_delete: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list: 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,

        // ------------------------------- subscription ------------------
        subs_man: 0,
        man_subs: 0,
        subscription_list: 0,
        subscription_view: 0,
        subscription_edit: 0,
        subscription_export: 0,
        subscription_hold: 0,
        subscription_complaints: 0,
        subscription_renewal: 0,
        subscription_payment: 0,
        subscription_drop: 0,
        subscription_special_case: 0,

        man_order: 0,
        order_list: 0,
        order_edit: 0,
        order_view: 0,
        order_new_subs: 0,
        order_drop_subs: 0,
        order_convert_subscriber: 0,

        man_drop: 0,
        drop_list: 0,
        drop_export: 0,

        // ----------------------------------- payment ------------------------
        pay_man: 0,
        man_payment: 0,
        payment_export: 0,
        payment_list: 0,

        man_refund: 0,
        refund_list: 0,
        refund_export: 0,
        refund_update: 0,

        // -------------------------- production ----------------------
        prod_man: 0,
        man_items: 0,
        item_catego: 0,
        item_category_list: 0,
        item_category_add: 0,
        item_category_edit: 0,
        item_category_delete: 0,

        item_sub_catego: 0,
        item_sub_category_list: 0,
        item_sub_category_add: 0,
        item_sub_category_edit: 0,
        item_sub_category_delete: 0,

        items: 0,
        items_list: 0,
        items_add: 0,
        items_edit: 0,
        items_view: 0,
        items_delete: 0,
        item_needed_material: 0,
        item_receipe_notes: 0,

        comp_man: 0,
        complaint_list: 0,
        complaint_add: 0,
        complaint_status: 0,
        complaint_view: 0,

        maintenance_man: 0,
        man_vehi: 0,
        vehicle_list: 0,
        vehicle_add: 0,
        vehicle_edit: 0,
        vehicle_view: 0,
        vehicle_delete: 0,
        vehicle_maintannce: 0,
        vehicle_export: 0,

        man_mainten: 0,
        maintenance_list: 0,
        maintenance_edit: 0,
        maintenance_status: 0
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const [hasFetched, setHasFetched] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [totalCount, setTotalCount] = useState(0);

    const [delivery, setDelivery] = useState([]);
    const [selectedDelivery, setSelectedDelivery] = useState(null);
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const tableRef = useRef(null);
    const [areas, setAreas] = useState([]);
    const [deliveryPoint, setDeliveryPoint] = useState(null);
    const [loading, setLoading] = useState(false);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const fetchData = async () => {
        try {
            setLoading(true);
            const params = {
                page,
                per_page: perPage,
                search: searchTerm,
                branch_id: branch_id
            };

            // Fetch areas
            const areasResponse = await axios.get(`${baseURL}/managearea`, { params });
            const areasData = Array.isArray(areasResponse.data.data.data)
                ? areasResponse.data.data.data
                : Array.isArray(areasResponse.data.data)
                    ? areasResponse.data.data
                    : [];
            setAreas(areasData);

            // Fetch delivery points
            const deliveryResponse = await axios.get(`${baseURL}/managedeliverypoint`, { params });
            const deliveryData = deliveryResponse.data.data;

            // Handle response structure
            let deliveryArray = [];
            if (deliveryData && Array.isArray(deliveryData.data)) {
                deliveryArray = deliveryData.data;
                setTotalCount(deliveryData.total || 0);
                setTotalPages(deliveryData.last_page || 1);
            } else if (Array.isArray(deliveryData)) {
                deliveryArray = deliveryData;
                setTotalCount(deliveryData.length || 0);
                setTotalPages(1);
            } else {
                deliveryArray = [];
                setTotalCount(0);
                setTotalPages(1);
            }

            // Group delivery points
            const groupedData = groupDeliveryPoints(deliveryArray, areasData);
            setDelivery(groupedData);

            setHasFetched(true);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setHasFetched(true); // Always set to true to indicate fetching is done
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [page, perPage, searchTerm]);

    const groupDeliveryPoints = (data, areasList) => {
        const grouped = {};

        data.forEach(item => {
            const dp = item.delivery_point;

            if (!grouped[dp]) {
                grouped[dp] = {
                    ...item,
                    areas: [],
                    id: item.id
                };
            }

            if (item.area_name && Array.isArray(item.area_name)) {
                item.area_name.forEach(area => {
                    const areaExists = areasList.find(a => a.sno === area.sno);
                    if (areaExists && !grouped[dp].areas.some(a => a.sno === area.sno)) {
                        grouped[dp].areas.push({
                            sno: area.sno,
                            area_name: areaExists.area_name || 'Unknown'
                        });
                    }
                });
            }
        });

        // Convert grouped object back to array
        return Object.values(grouped);
    };

    const handleModalToggle = (data) => {
        setSelectedDelivery(data);
        setModalType("Add");
        setOpen(true);
    };

    const handleModalToggle_Edit = () => {
        setModalType("Edit");
        setOpen(true);
    };

    const DeleteModal = (item) => {
        swal.fire({
            html: `
                  <div class="alert alert-danger px-2 py-2" role="alert">
                      <strong>OOPS! </strong> You're about to lose one Delivery Point
                      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                  </div>
                  <p class="text-center"><b>${item.delivery_point}</b></p>
                  <div class="text-center">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                          <defs>
                              <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                  <stop offset="0" stop-color="#5987dd"/>
                                  <stop offset=".118" stop-color="#638bd6"/>
                                  <stop offset=".316" stop-color="#7d98c3"/>
                                  <stop offset=".572" stop-color="#a8aba3"/>
                                  <stop offset=".871" stop-color="#e3c678"/>
                                  <stop offset="1" stop-color="#ffd364"/>
                              </radialGradient>
                              <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                          </defs>
                          <g id="_27-feel_bad" data-name="27-feel bad">
                              <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                              <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                              <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                              <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                              <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                              <circle class="cls-6" cx="34" cy="22" r="1"/>
                              <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                              <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                              <circle class="cls-6" cx="16" cy="22" r="1"/>
                              <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                              <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                              <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                              <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                              <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                              <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                              <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                              <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                              <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                              <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                              <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                          </g>
                      </svg>
                  </div>
              `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(async (result) => {
            if (result.isConfirmed) {
                axios.delete(`${baseURL}/managedeliverypoint/${item.sno}`)
                    .then(response => {
                        // Remove the deleted item from state
                        setDelivery(prev => prev.filter(b => b.sno !== item.sno));
                        fetchData();
                        swal.fire('Deleted!', 'Delivery Point has been deleted.', 'success');
                        // window.location.reload();
                    })
                    .catch(error => {
                        console.log("Error deleting delivery point:", error);
                        swal.fire('Error', 'Something went wrong while deleting.', 'error');
                    });
            }
        });
    };

    const handleStatusToggle = async (id, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;
        axios.put(`${baseURL}/managedeliverypoint/status/${id}`, { status: newStatus })
            .then(response => {
                fetchData();
                toast.success("Status Updated Successfully!");
                // window.location.reload();
            })
            .catch(error => {
                console.log(error);
                toast.error("Status Updation Failed");
            });
    };

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "destroy": true,
                        "paging": false,
                        "searching": false,
                        "info": false,
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched, delivery]);

//29.10.2025
    // const branch_id = parseInt(localStorage.getItem("branch_id"), 10) || 1;

const [isMaintenance, setIsMaintenance] = useState(false);
//const [loading, setLoading] = useState(true);

useEffect(() => {
    let isMounted = true;

    const checkMaintenanceStatus = async () => {
        try {
            const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
            const data = response.data.data || [];
            const branchStatus = data.find((item) => item.slug === "managedeliverypoint"); // use managebranch slug

            if (isMounted) {
                setIsMaintenance(branchStatus?.maintenancemode_status === 1);
            }
        } catch (error) {
            console.error("Error checking maintenance mode:", error);
            if (isMounted) setIsMaintenance(false);
        } finally {
            if (isMounted) setLoading(false);
        }
    };

    checkMaintenanceStatus();

    return () => {
        isMounted = false;
    };
}, [baseURL, branch_id]);

if (loading) {
    return <div>Loading...</div>; // optional loading state
}

if (isMaintenance) {
    return (
        <div
            className="d-flex flex-column align-items-center justify-content-center text-center"
            style={{ height: "100vh", width: "100vw" }}
        >
            <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
            <p className="text-muted fs-5">
                The <strong>Manage Delivery Area </strong> module is currently under maintenance. <br />
                Please check back later.
            </p>
        </div>
    );
}
//29.10.2025

    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                <div className=''>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Delivery Point</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Branch Management</li>
                    </ol>
                </div>
                {open && modalType === "Edit" && (
                    <Edit show={open} onClose={() => setOpen(false)} deliveryPoint={selectedDelivery}
                        onUpdated={() => {
                            fetchData();
                        }} />
                )}
                <LoadingComponent loading={loading} />
                {open && modalType === "Add" && (
                    <AssignVehicle show={open} onClose={() => setOpen(false)} data={selectedDelivery} refresh={fetchData} />
                )}

            </div>

            {permissions.dpoint_list === 1 && (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{ fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); // Reset to first page
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{ fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1); // Reset page on new search
                                }}
                            />
                        </div>
                    </div>

                    <table ref={tableRef} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                                <th className='min-w-150px'>Delivery Point</th>
                                <th className='min-w-150px'>Area</th>
                                <th className='min-w-150px'>Branch</th>
                                <th className='min-w-50px'>Status</th>
                                <th className='min-w-50px text-center'>Actions</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7 align-top">
                            {delivery.map((item) => (
                                <tr key={item.sno}>
                                    <td>
                                        <div className='text-black font-w400 fs-7'>{item.delivery_point}</div>
                                    </td>
                                    <td>
                                        <div className='text-black font-w400 fs-7 w-200px text-wrap'>
                                            {item.areas && item.areas.length > 0
                                                ? item.areas.map(area => area.area_name || area.name || 'Unknown').join(', ')
                                                : 'No Areas'}
                                        </div>
                                    </td>
                                    <td>
                                        <div className='text-black font-w400 fs-7'>{item.branch_data ? item.branch_data.branch_name : 'N/A'}</div>
                                    </td>
                                    <td>
                                        <div className="form-check form-switch d-flex align-items-center mb-3">
                                            <input className="form-check-input me-2" type="checkbox" role="switch" checked={item.status === 0} onChange={() => handleStatusToggle(item.sno, item.status)} disabled={permissions.dpoint_edit !== 1} />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-center">
                                            {permissions.dpoint_assign_vehicle === 1 && (
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Assign Vehicle</span></Tooltip>} >
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle(item)}>
                                                        <span><i className="fa-solid fa-truck fs-5 mt-1"></i></span>
                                                    </Button>
                                                </OverlayTrigger>
                                            )}

                                            {permissions.dpoint_edit === 1 && (
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => {
                                                        // console.log('Editing delivery point:', item);
                                                        setSelectedDelivery(item);
                                                        handleModalToggle_Edit();
                                                    }}>
                                                        <span><i className="fa-solid fa-pen-to-square fs-5 mt-1"></i></span>
                                                    </Button>
                                                </OverlayTrigger>
                                            )}

                                            {permissions.dpoint_delete === 1 && (
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>} >
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => DeleteModal(item)}>
                                                        <span><i className="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                                    </Button>
                                                </OverlayTrigger>
                                            )}

                                            {permissions.dpoint_assign_vehicle != 1 && permissions.dpoint_edit != 1 && permissions.dpoint_delete != 1 && (
                                                <div className="text-center">
                                                    No Actions
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {delivery.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + delivery.length} of {totalCount} entries
                                </span>
                            ) : (
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                    </li>
                                ))}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>

                    </div>
                </div>
            )}

            {permissions.dpoint_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

        </>
    )


}
export default Delivery_Point;